export const DRAW_STATE_TEXTS = {
  CANCELLED: 'Inställd omgång',
  NOT_OPENED: 'Omgång ej startad',
  FINISHED: 'Avslutad',
};
